<h6 class="loginHeadingText text-start pt-3 mb-2 mt-2 ps-1">PROJECT COST ESTIMATES</h6>
<div class="lightBg mt-3 pb-1 mb-2" *ngIf="selectedProjectCost!">
    <div class="row align-items-center mb-3">
        <!-- Select Agency -->
        <div class="col-md-3 pe-0">
            <label class="form-label mb-0">SELECT 3RD PARTY / AGENCY</label>
        </div>
        <div class="col-md-3">
            <select class="form-select" [(ngModel)]="selectedAgency" (ngModelChange)="onAnyFieldValueChange($event)"
                (change)="onThridPartyAgencyChange($event)">
                <option value="0" selected>Select Agency</option>
                <option *ngFor="let item of thirdPartyAgencies" [ngValue]="item.categoryAgencyID">
                    {{ item.categoryName }} - {{ item.agencyName }}
                </option>
            </select>
        </div>
        <!-- Total Stores -->
        <div class="col-md-3 text-end">
            <label class="form-label mb-0 me-2 lblText">TOTAL STORES:</label>
            <span style="font-weight: bolder;">{{ storesCount === -1 ? 0 : storesCount }}</span>
        </div>

        <!-- Cost Calculated For -->
        <div class="col-md-3 pe-0">
            <label class="form-label mb-0 me-2 lblText">COST CALCULATED FOR:</label>
            <span style="color: red;font-weight: bolder;"> {{ getTotalProjectCostStores() }}</span>
        </div>

    </div>

    <div class="row mb-12px">
        <table class="table datatable border-x-0 mb-0">
            <tbody>
                <tr class="subheaderrr">
                    <th width="1%"></th>
                    <th width="10%"># STORES</th>
                    <th width="10%">Hours / Store</th>
                    <th width="10%">Cost / Hour</th>
                    <th width="10%">Shipping Cost / STORE</th>
                    <th width="10%"># of Visits</th>
                    <th class="border-end-0" width="2%"></th>
                </tr>
                <tr *ngFor="let item of selectedProjectCost; let i = index" class="project-cost-row">
                    <td class="align-middle">
                        <img src="assets/images/plus_icon.svg" alt="" (click)="addProjectCostItem(i+1)">
                    </td>
                    <td class="text-end">
                        <input type="number" class="form-control no-spinners text-end" min="1"
                            value="Auto-populated from Store List" [(ngModel)]="item!.numberOfStores"
                            (input)="calculateHours()" (keydown)="restrictZeroAndDotInput($event)" />
                    </td>
                    <td class="text-end">
                        <input type="number" class="form-control no-spinners text-end" min="0"
                            [(ngModel)]="item!.hoursPerLocation" (ngModelChange)="onAnyFieldValueChange($event)"
                            (input)="calculateHours();" (keypress)="onKeyPress($event)" (keydown)="restrictZeroOnly($event)" />
                    </td>
                    <td class="text-end">
                        <input type="text" class="form-control no-spinners text-end" min="0" [disabled]="!isSRETeam"
                            [value]="selectedAgency && selectedAgency > 0 && item?.costPerHour != null 
                                ? formatCurrency(item.costPerHour) 
                                : ''" (input)="onCostPerHourChange($event, i)" (keypress)="onKeyPress($event)" />
                    </td>
                    <td class="text-end">
                        <input type="text" class="form-control no-spinners text-end" min="0" [value]="item?.costOfShippingStore != null && item?.costOfShippingStore !== 0
                                ? formatCurrency(item.costOfShippingStore) 
                                : ''" (input)="onCostOfShippingStoreChange($event, i)"
                            (keypress)="onKeyPress($event)" />
                    </td>

                    <td class="text-end">
                        <input type="number" class="form-control no-spinners text-end" min="1"
                            [value]="item?.numberOfVisits || null" [(ngModel)]="item.numberOfVisits"
                            (input)="calculateHours();" (keydown)="restrictZeroAndDotInput($event)"/>
                    </td>
                    <td class="col align-self-center text-center">
                        <img src="assets/images/close_mark.svg" alt="" (click)="removeProjectCostItem(i)" *ngIf="selectedProjectCost.length > 1">
                    </td>
                </tr>
                <tr class="fw-bold table-secondary sticky-footer-2" *ngIf="selectedProjectCost.length > 0">
                    <td width="1%" class="text-end">TOTAL</td>

                    <!-- Total Stores -->
                    <td width="10%" class="text-end align-adjust">
                        {{ getTotalProjectCostStores() }}
                    </td>

                    <!-- Total Hours (No.of Stores * Hours/Store) -->
                    <td width="10%" class="text-end align-adjust">
                        {{ getTotalHours() }}
                    </td>

                    <!-- Total Cost (Hours/Store * Cost / Hour) -->
                    <td width="10%" class="text-end align-adjust">
                        {{ formatCurrency(getTotalCostPerHour()) }}
                    </td>

                    <!-- Total Shipping Cost (No.of Stores * Shipping Cost/Store) -->
                    <td width="10%" class="text-end align-adjust">
                        {{ formatCurrency(getTotalShippingCost()) }}
                    </td>

                    <!-- Total Visits -->
                    <td width="10%" class="text-end align-adjust" style="border-right: transparent !important;">
                        {{ getTotalVisits() }}
                    </td>
                    <td></td>
                </tr>
                <tr class="sticky-footer">
                    <td colspan="4" class="text-end">
                        <label for="" class="text-danger no-spinners" min="0">ESTIMATED TOTAL COST</label>
                    </td>
                    <td class="text-end align-adjust" style="border-right: transparent !important;">
                        <span *ngIf="totalEstimatedCost > 0">
                            {{ formatCurrency(totalEstimatedCost) }}
                        </span>
                        <span *ngIf="totalEstimatedCost < 0">
                            {{ '' }}
                        </span>
                    </td>
                    <td colspan="2">

                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</div>